class AlgoliaArticles extends HTMLElement {
  constructor() {
    super();

    // Index name
    this.indexName = `${algoliaShopify.config.index_prefix}articles`;

    // Component data
    this.loaded = false;
    this.indexAdjust = 0;
    this.blogHandle = this.dataset.blogHandle;
    this.blogTitle = this.dataset.blogTitle;
    this.sectionId = this.dataset.sectionId;
    this.queryId = '';

    setTimeout(() => {
      this.init();
    }, 10);
  }

  init() { 
    const urlParams = new URLSearchParams(window.location.search);

    // Algolia search client
    this.searchClient = algoliaShopify.externals.algoliasearch(
      algoliaShopify.config.app_id,
      algoliaShopify.config.search_api_key,
      {
        headers: {
          'X-Algolia-UserToken': getAlgoliaUserToken(),
        },
      }
    );

    this.articlesIndex = this.searchClient.initIndex(
      `${algoliaShopify.config.index_prefix}articles`
    );

    // Initial state

    this.hitsPerPage = 12;
    this.currentPage = 0;    

    urlParams.forEach((value, key) => {
      if (key == 'page') {
        this.currentPage = parseInt(value);
      }
    });

    // DOM elements
    this.articlesList = document.querySelector('#AlgoliaArticlesList');
    this.paginationContainer = document.querySelector('#AlgoliaPagination');
    this.paginationCount = document.querySelector('#AlgoliaPaginationCount');

    if (this.paginationContainer) {
      this.paginationContainer
        .querySelector('.blog__pagination-button--prev')
        .addEventListener('click', this.onPaginationPrev.bind(this));

      this.paginationContainer
        .querySelector('.blog__pagination-button--next')
        .addEventListener('click', this.onPaginationNext.bind(this));
    }

    window.addEventListener('popstate', (event) => {
      this.currentPage = event.state ? event.state.page : 0;
      this.search();
    });

    // Initial search. 
    this.search();
  }

  /**
   * Reset the product list.
   */
  resetArticlesList() {
    this.currentPage = 0;
    this.articlesList.innerHTML = '';
  }  

  /**
   * Search algoliaShopify for the article data.
   * @param {boolean} paginationTriggered - Whether the search is triggered by a pagination event.
   */
  search(paginationTriggered = false) {  
    const params = {
      page: this.currentPage,
      hitsPerPage: this.hitsPerPage,
      facetFilters: [`blog.title:${this.blogHandle}`],
      clickAnalytics: true
    };

    this.articlesIndex.search("", params).then((query) => {      
      console.log('=============');
      console.log(query);
      console.log('=============');

      this.articlesList.innerHTML = '';      

      this.generateArticlesFromHits(query.hits);
      this.generatePaginationFromResults(query);

      if (paginationTriggered) {
        // Scroll to the top of the articles list
        this.articlesList.scrollIntoView({ behavior: 'smooth' });
      }
    });

    this.loaded = true;
  }

  /**
   * Generate the product cards from the hits.
   * @param {object} hits - The product hits from the algoliaShopify API.
   */
  generateArticlesFromHits(hits) {
    hits.forEach((hit, index) => {
      const li = document.createElement('li');
      li.classList.add('grid__item', 'blog__article');

      const card = document.createElement('div');
      card.classList.add('card', 'card--article');

      const imageLink = document.createElement('a');
      imageLink.classList.add('card__link', 'link--unstyled');
      imageLink.href = `/blogs/${this.dataset.blogHandle}/${hit.handle}`;

      const imageWrapper = document.createElement('div');
      imageWrapper.classList.add('card__image-wrapper');

      const imageContainer = document.createElement('div');
      imageContainer.classList.add('card__image-container');

      const media = document.createElement('div');
      media.classList.add('media', 'media--landscape');

      const image = document.createElement('img');
      image.classList.add('motion-reduce');
      image.loading = 'lazy';
      image.width = 540;
      image.height = 540;
      image.src = hit.image + '&width=540';
      image.srcset = `${hit.image + '&width=180'} 180w, ${hit.image + '&width=360'} 360w, ${hit.image + '&width=540'} 540w, ${hit.image + '&width=720'} 720w, ${hit.image + '&width=900'} 900w, ${hit.image + '&width=1080'} 1080w`;
      image.alt = hit.title;

      media.appendChild(image);
      imageContainer.appendChild(media);
      imageWrapper.appendChild(imageContainer);
      imageLink.appendChild(imageWrapper);

      const details = document.createElement('div');
      details.classList.add('card__details');

      const title = document.createElement('div');
      title.classList.add('card__title');

      const titleSpan = document.createElement('span');
      titleSpan.classList.add('card__title-title');
      titleSpan.innerHTML = hit.title;

      const subtitle = document.createElement('div');
      subtitle.classList.add('card__subtitle', 'special');
      subtitle.innerHTML = new Date(hit.created_at).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replaceAll('/', '.');

      title.appendChild(titleSpan);

      details.appendChild(title);
      details.appendChild(subtitle);

      card.appendChild(imageLink);
      card.appendChild(details);

      li.appendChild(card);

      this.articlesList.appendChild(li);
    });
  }

  /**
   * Generate the pagination from the results.
   * @param {object} results - The results from the algoliaShopify API.
   */
  generatePaginationFromResults(results) {
    if (results.nbPages == 0) {
      this.paginationContainer.remove();
      return;
    }

    const prevButton = this.paginationContainer.querySelector(
      '.blog__pagination-button--prev'
    );
    const nextButton = this.paginationContainer.querySelector(
      '.blog__pagination-button--next'
    );

    if (results.page == 0) {
      prevButton.disabled = true;
    } else {
      prevButton.disabled = false;
    }

    if (results.page == results.nbPages - 1) {
      nextButton.disabled = true;
    } else {
      nextButton.disabled = false;
    }

    this.paginationCount.innerHTML = window.paginationStrings.of.replace(
      '{{ index }}',
      results.page + 1
    ).replace(
      '{{ number }}',
      results.nbPages
    );
  }

  onPaginationPrev() {
    this.currentPage--;

    this.updateURLHash();

    this.search(true);
  }

  onPaginationNext() {
    this.currentPage++;

    this.updateURLHash();

    this.search(true);
  }

  /**
   * Update the URL hash.
   */
  updateURLHash() {
    const params = new URLSearchParams();

    if (this.currentPage !== 0) {
      params.set('page', this.currentPage);
    }

    const queryString = params.toString();
    const newUrl = queryString
      ? `${window.location.pathname}?${queryString}`
      : window.location.pathname;

    history.pushState(
      {
        page: this.currentPage,
      },
      '',
      newUrl
    );
  }
}

customElements.define('algolia-articles', AlgoliaArticles);